import { lazy } from 'react';

import MainLayout from 'layout/MainLayout';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

const HomePage = Loadable(lazy(() => import('pages/extra-pages/WelcomePage')));
const OutboxPage = Loadable(lazy(() => import('pages/extra-pages/OutboxPage')));
const SearchProfilePage = Loadable(lazy(() => import('pages/extra-pages/SearchProfilePage')));
const ProfilePage = Loadable(lazy(() => import('pages/extra-pages/ProfilePage')));
const ShareCardPreviewPage = Loadable(lazy(() => import('pages/extra-pages/ShareCardPreviewPage')));
const SendMessagePage = Loadable(lazy(() => import('pages/extra-pages/SendMessagePage')));
const InboxPage = Loadable(lazy(() => import('pages/extra-pages/InboxPage')));

const SettingsPage = Loadable(lazy(() => import('pages/extra-pages/settings/SettingsPage')));
const BlockedList = Loadable(lazy(() => import('pages/extra-pages/settings/items/blocked-users/BlockedList')));
const WalletConnectionPage = Loadable(lazy(() => import('pages/extra-pages/settings/items/wallet/WalletConnectionPage')));
const PaymentHistoryPage = Loadable(lazy(() => import('pages/extra-pages/settings/items/wallet/PaymentHistoryPage')));
const EditProfile = Loadable(lazy(() => import('pages/extra-pages/settings/items/edit-profile/EditProfile')));
const HelpFeedback = Loadable(lazy(() => import('pages/extra-pages/settings/items/info/HelpAndFeedback')));
const TermsOfService = Loadable(lazy(() => import('pages/extra-pages/settings/items/info/TermsOfService')));
const PrivacyPolicy = Loadable(lazy(() => import('pages/extra-pages/settings/items/info/PrivacyPolicy')));
const About = Loadable(lazy(() => import('pages/extra-pages/settings/items/info/About')));
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <CommonLayout />,
      children: [
        {
          index: true,
          element: <HomePage />
        }
      ]
    },
    {
      path: '/',
      element: <MainLayout />,
      children: [
        {
          path: 'home',
          element: <ProfilePage />
        },
        {
          path: 'settings',
          element: <SettingsPage />
        },
        {
          path: 'profile',
          element: <ProfilePage />
        },
        {
          path: 'share/:messageId',
          element: <ShareCardPreviewPage />
        },
        {
          path: 'send/:recipient_slug',
          element: <SendMessagePage />
        },
        {
          path: 'inbox',
          element: <InboxPage />
        },
        {
          path: 'outbox',
          element: <OutboxPage />
        },
        {
          path: 'search',
          element: <SearchProfilePage />
        },
        {
          path: 'search/:slug',
          element: <SearchProfilePage />
        }
      ]
    },
    {
      path: '/settings',
      element: <MainLayout />,
      children: [
        {
          path: 'privacy_policy',
          element: <PrivacyPolicy />
        },
        {
          path: 'terms_of_use',
          element: <TermsOfService />
        },
        {
          path: 'edit_profile',
          element: <EditProfile />
        },
        {
          path: 'help_and_feedback',
          element: <HelpFeedback />
        },
        {
          path: 'wallet',
          element: <WalletConnectionPage />
        },
        {
          path: 'history',
          element: <PaymentHistoryPage />
        },
        {
          path: 'blocked_list',
          element: <BlockedList />
        },
        {
          path: 'about',
          element: <About />
        }
      ]
    },
    {
      path: '/maintenance',
      element: <CommonLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        }
      ]
    },
    {
      path: '/',
      element: <CommonLayout />,
      children: [
        {
          path: '*',
          element: <MaintenanceError />
        }
      ]
    }
  ]
};

export default MainRoutes;
